import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/topics", label: "爆料专题" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    [
      "relative font-label text-sm transition-colors duration-200 whitespace-nowrap",
      isActive
        ? "text-primary-600 font-semibold"
        : "text-foreground-700 hover:text-primary-600",
    ].join(" ");

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 md:h-[72px] items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-3" aria-label="吃瓜深扒社 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-eye-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950">
              吃瓜深扒社
            </span>
            <span className="mt-1 hidden text-[11px] tracking-[0.18em] text-secondary-500 sm:block">
              PAGEANT NOTES
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/about#contact"
            className="hidden md:inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-mail-send-line" aria-hidden="true"></i>
            投递线索
          </Link>
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
            aria-label={open ? "关闭菜单" : "展开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-100 px-4 py-3 md:hidden"
          aria-label="移动端导航"
        >
          <ul className="flex flex-col">
            {navItems.map((item) => {
              const active = location.pathname === item.to;
              return (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={() => setOpen(false)}
                    className={[
                      "flex items-center justify-between rounded-md px-3 py-3 font-label text-sm transition-colors",
                      active
                        ? "bg-primary-100 text-primary-700 font-semibold"
                        : "text-foreground-800 hover:bg-background-200",
                    ].join(" ")}
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                  </Link>
                </li>
              );
            })}
            <li className="mt-2">
              <Link
                to="/about#contact"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-2 rounded-md bg-primary-500 px-3 py-3 font-label text-sm font-medium text-background-50"
              >
                <i className="ri-mail-send-line" aria-hidden="true"></i>
                投递线索
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}